import React from "react";

import ShortAnswer from "./ShortAnswer";

const LongAnswerQuestion = (props) => <ShortAnswer multiline {...props} />;

export default React.memo(LongAnswerQuestion);
